import * as Icons from '../assets/icons';

export const icon: Record<string, keyof typeof Icons> = {
	IconHeart: 'IconHeartGreen',
	IconHeartFilled: 'IconHeartFilledGreen',
};
